import Immutable from "immutable";

import createStore from "./createStore";

export const reducer = createStore({
    SET_DASHBOARD_DATA_FOR_EVENT: (state, action) =>
        state.set(
            action.event_id,
            state
                .get(action.event_id, Immutable.Map())
                .merge(Immutable.fromJS(action.data)),
        ),
});
